var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Transportadora", prop: "logisticProviderId" } },
          [
            _c("sc-logistic-provider-dropdown", {
              model: {
                value: _vm.filters.logisticProviderId,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "logisticProviderId", $$v)
                },
                expression: "filters.logisticProviderId"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Status", prop: "status" } },
          [
            _c("sc-logs-reverse-status", {
              attrs: { "option-all": true },
              model: {
                value: _vm.filters.status,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "status", $$v)
                },
                expression: "filters.status"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Período", prop: "dateRange" } },
          [
            _c("sc-range-date-picker", {
              attrs: { format: _vm.formatDate },
              model: {
                value: _vm.filters.dateRange,
                callback: function($$v) {
                  _vm.$set(_vm.filters, "dateRange", $$v)
                },
                expression: "filters.dateRange"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7edf9194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edf9194","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/components/sc-logs-reverse-filters/ScLogsReverseFilters.vue
// module id = null
// module chunks = 